import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  isExist: false,

  tagList: [],
  categoryList: [],
  productCategoryList: [],
  storeList: [],

  promotionList: [],
  serviceAreaList: [],

  pageInfo: {
    page: 1,
    totalPage: 2,
    limit: 10
  },
  cacheMeta: {
    tagListFetchedAt: 0,
    categoryListFetchedAt: 0,
    locationFetchedAt: 0,
    locationKey: ''
  },
  condition: {
    page: 1,
    limit: 10
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
